export const EventTypes ={
    ADD_MODEL : "ModelRegister.AddModel",
    REMOVE_MODEL : "ModeRegister.RemoveModel",
    SELECT_MODEL : "ModelRegister.SelectModel"
};